import { useEffect, useRef, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from 'react-select'
import InvalidFeedback from "../../../components/InvalidFeedback";
import { AlertService } from '../../../services/Alert'
import { FollowUpService } from '../../../services/FollowUpService'
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";
import { AccountService } from "../../../services/AccountsService";
import Button from "../../../components/form-controls/Button";
import useModal from "../../../hooks/useModal";
import { useTranslation } from 'react-i18next'
interface FormModalProps {
    show: boolean;
    onRequestClose: () => void
    ticket: string
    fromAgentid: number
}


export default function ModalRedirect({ show, onRequestClose, ticket, fromAgentid }: FormModalProps) {

    const { t } = useTranslation();
    const { account } = useCurrentAccount();
    const modalRedirectRef = useRef<HTMLDivElement>(null);
    const [filterAgent, setFilterAgent] = useState('');
    const [Agents, setAgents] = useState([]);

    useModal(modalRedirectRef, show)

    const defaultValues = {
        filtersAgent: '',
        ticket: ticket,
        from_agent_id: fromAgentid,
        to_agent_id: ''
    }

    const { control, register, watch, handleSubmit, reset, formState: { errors, isValid, isSubmitting } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const filtersAgent = watch('filtersAgent');

    const getAgentsData = async () => {
        const { data } = await FollowUpService.getAgents(account.id);
        const response = await AccountService.getSubaccounts(account.id)
        let options;
        switch (filterAgent) {
            case '1': // Conectado
                options = data.filter(agent => agent.status === 'Online');
                break;
            case '2': // Desconectado
                options = data.filter(agent => agent.status === 'Offline');
                break;
            case '3': // Subcuenta
                options = response.data.sub_accounts
                    .filter(item => item.status === 1)
                    .map(item => ({
                        value: item.id,
                        label: item.name
                    }));
                break;
            case '4': // Todos
                options = data;
                break;
            default:
                options = [];
        }
        if (filterAgent !== '3') {
            options = options.map(agent => ({
                value: agent.agent_id,
                label: agent.username
            }));
        }

        setAgents(options);
    };
    const closeAndReset = () => {
        reset(defaultValues);
        onRequestClose();
    }

    const submit = async (data) => {

        if (filtersAgent != '3') {
            const { filtersAgent, ...restData } = data;
            AlertService.warning(t("follow-up.tickets.chat-view.question-redirect"), t("follow-up.tickets.chat-view.text-redirect"), async () => {
                try {
                    await FollowUpService.redirectTickets(restData)
                    AlertService.toastSuccess(t("follow-up.tickets.chat-view.toast-success-redirect"))
                    const event = new CustomEvent('updateTickets');
                    window.dispatchEvent(event);
                    closeAndReset();
                } catch (error) {
                    console.error(error);
                    AlertService.error('¡Error!', t("follow-up.tickets.chat-view.alert-error-redirect"))
                }
            });
        } else {
            AlertService.warning(t("follow-up.tickets.chat-view.question-redirect"), t("follow-up.tickets.chat-view.text-redirect"), async () => {
                try {
                    await FollowUpService.redirectTicketsbySubAccount(data.to_agent_id, data.ticket)
                    AlertService.toastSuccess(t("follow-up.tickets.chat-view.toast-success-redirect"))
                    const event = new CustomEvent('updateTickets');
                    window.dispatchEvent(event);
                    closeAndReset();
                } catch (error) {
                    console.error(error);
                    AlertService.error('¡Error!', t("follow-up.tickets.chat-view.alert-error-redirect"))
                }
            });
        }
    }

    useEffect(() => {
        getAgentsData();
        reset({ ...defaultValues, ticket });
    }, [ticket]);

    useEffect(() => {
        getAgentsData();
    }, [filterAgent]);



    return (
        <div className="modal fade" ref={modalRedirectRef} data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog" role="document">
                <form onSubmit={handleSubmit(submit)}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">{t("follow-up.tickets.chat-view.modal-title")}</h4>
                            <button type="button" className="btn-close" onClick={closeAndReset}></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label className='form-label'>{t("follow-up.tickets.chat-view.modal-input-1")}</label>
                                <Controller
                                    control={control}
                                    name='filtersAgent'
                                    rules={{ required: true }}
                                    render={({
                                        field: { onChange, value },
                                        fieldState: { error }
                                    }) => {
                                        const defaultValue = [
                                            { value: '1', label: t("follow-up.tickets.chat-view.modal-option-1") },
                                            { value: '2', label: t("follow-up.tickets.chat-view.modal-option-2") },
                                            { value: '3', label: t("follow-up.tickets.chat-view.modal-option-3") },
                                            { value: '4', label: t("follow-up.tickets.chat-view.modal-option-4") },
                                        ];
                                        return (
                                            <>
                                                <Select
                                                    options={defaultValue}
                                                    isMulti={false}
                                                    className={'form-select-custom'}
                                                    classNamePrefix='form-select-custom'
                                                    placeholder={t("follow-up.tickets.chat-view.modal-input-1-ph")}
                                                    onChange={(selectedOption) => {
                                                        if (typeof selectedOption === 'object' && selectedOption !== null && 'value' in selectedOption) {
                                                            onChange(selectedOption.value);
                                                            setFilterAgent(selectedOption.value);
                                                        }
                                                    }}
                                                    value={defaultValue.find(option => option.value === value) || ''}
                                                />
                                                <InvalidFeedback error={error} />
                                            </>
                                        )
                                    }}
                                />
                            </div>
                            <div className="mb-3">
                                <label className='form-label'>{t("follow-up.tickets.chat-view.modal-input-2")}</label>
                                <Controller
                                    control={control}
                                    name='to_agent_id'
                                    rules={{ required: true }}
                                    render={({
                                        field: { onChange, value },
                                        fieldState: { error }
                                    }) => (
                                        <>
                                            <Select
                                                options={Agents}
                                                isMulti={false}
                                                className={'form-select-custom'}
                                                classNamePrefix='form-select-custom'
                                                placeholder={t("follow-up.tickets.chat-view.modal-input-2-ph")}
                                                onChange={(option) => {
                                                    onChange(option.value);
                                                }}
                                                value={Agents.find(option => option.value === value) || ''}
                                            />
                                            {error && <InvalidFeedback error={error} />}
                                        </>
                                    )}
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-white btn-sm" onClick={closeAndReset}>{t("btn-cancel")}</button>
                            <Button type="submit" className="btn btn-primary btn-sm" disabled={!isValid} isLoading={isSubmitting} onClick={handleSubmit(submit)}>{t("btn-save")}</Button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
